import { NudosGenericModal, NudosModalContent } from 'components/NudosComponents';
import { IQuoteItemDetailsForQuoteManagement } from 'types/quoteEditor.types';
import SuggestReasonModalContent from './SuggestReasonModalContent';
import './SuggestReasonModalContent.scss';

interface ISuggestReasonModal {
  device: IQuoteItemDetailsForQuoteManagement;
  onClose: () => void;
  onConfirm: (reasonId: number, reasonName: string) => void;
}

/**
 * Modal para seleccionar el motivo antes de sugerir herramientas alternativas.
 * Envuelve el overlay genérico y delega el contenido a SuggestReasonModalContent.
 */
const SuggestReasonModal = (props: ISuggestReasonModal) => {
  return (
    <NudosGenericModal
      closeModalCallback={props.onClose}
      clickOutsideCallback={props.onClose}
      customClassName="suggestReasonModal"
      modalContent={
        <NudosModalContent
          customWidth="58rem"
          customHeight="auto"
          excludeHeader
          isSectionContainerFull
          CustomModalComponent={<SuggestReasonModalContent {...props} />}
        />
      }
    />
  );
};

export default SuggestReasonModal;
